export default __webpack_public_path__ + "static/media/914P.188d945f.jpg";